import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppContext } from './context.tsx';
import { resetSelectedCountry } from '../store/slice/SelectedCountrySlice';

export const useResetAll = () => {
  const { resetState } = useAppContext();
  const dispatch = useDispatch();
  return useCallback(() => {
    resetState();
    dispatch(resetSelectedCountry());
  }, [resetState, dispatch]);
};